export default {
    section: 'Broker Dealer',
    name: 'offer-letter-broker-dealer',
    items: [
        {
            type: 'selectlist',
            text: 'Current Broker-Dealer',
            name: 'offer-letter-broker-dealer-broker-dealer',
            props: {
                label: 'Broker-Dealer',
                items: 'broker_dealers'
            },
            subItems: [
                {
                    "name": "offer-letter-broker-dealer-broker-dealer-description",
                    "type": "text-field",
                    "props": {
                        "label": "Name of other Broker-Dealer"
                    },
                    "dependencies": {
                        "items": [
                            {
                                "name": "offer-letter-broker-dealer-broker-dealer",
                                "value": "other"
                            }
                        ]
                    },
                },
                {
                    type: 'radio-list',
                    text: ' ',
                    name: 'offer-letter-broker-dealer-broker-dealer-movement',
                    props: [
                        {
                            text: 'Buyer to stay at',
                            value: 'buyer-stay'
                        },
                        {
                            text: 'Buyer to move to',
                            value: 'buyer-move'
                        },
                        {
                            text: 'Seller to move to',
                            value: 'seller-move'
                        }
                    ]
                }
            ]
        },
        {
            type: 'text-field',
            text: 'Current Custodian',
            name: 'offer-letter-broker-dealer-custodian',
            props: {
                label: 'Custodian'
            },
            subItems: [
                {
                    type: 'radio-list',
                    text: ' ',
                    name: 'offer-letter-broker-dealer-custodian-movement',
                    props: [
                        {
                            text: 'Buyer to stay at',
                            value: 'buyer-stay'
                        },
                        {
                            text: 'Buyer to move to',
                            value: 'buyer-move'
                        },
                        {
                            text: 'Seller to move to',
                            value: 'seller-move'
                        }
                    ]
                }
            ]
        },
        {
            type: 'text-field',
            text: 'Current TAMP',
            name: 'offer-letter-broker-dealer-tamp',
            props: {
                label: 'TAMP'
            },
            subItems: [
                {
                    type: 'radio-list',
                    text: ' ',
                    name: 'offer-letter-broker-dealer-tamp-movement',
                    props: [
                        {
                            text: 'Buyer to stay at',
                            value: 'buyer-stay'
                        },
                        {
                            text: 'Buyer to move to',
                            value: 'buyer-move'
                        },
                        {
                            text: 'Seller to move to',
                            value: 'seller-move'
                        }
                    ]
                }
            ]
        },
        {
            type: 'textarea',
            text: 'Notes',
            name: 'offer-letter-broker-dealer-notes',
            props: {}
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/offer-letter/valuation-data/broker-dealer.js